import { CircularProgress, makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles({
    customColor: {
        color: '#593686', // Set your desired color here
    },
});

const LoadingSpinner = (center = true) => {
    const loader = useStyles();
    return (
        <>
            {center ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress className={loader.customColor} size={60} />
                </div>
            ) : (
                <CircularProgress className={loader.customColor} size={60} />
            )}
        </>
    );
};

export default LoadingSpinner;
